import { getInfo, getKey, getTotalTime, getChosenAddons } from '../general.js';

export default async function listAvailableDays() {
    const addons = getChosenAddons();
    let loanerCar = false;
    if(addons && addons.length > 0 && addons.findIndex(addon => addon.loanerCar) > -1) {
        loanerCar = true;
    }

    const info = getInfo();
    const form = new FormData();
    form.append('action', 'nobox_list_days');
    form.append('regno', info.regno);
    form.append('key', getKey());
    form.append('resources', getTotalTime());
    form.append('loanerCar', loanerCar);
    const params = new URLSearchParams(form);

    let events;
    await fetch(horizon.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        body: params
    })
    .then(response => response.json())
    .then(data => {
        events = data;
    })
    return events;
}
